import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'modal',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.letters[props.index] = next
    })
  }
}
